import Swiper, {Navigation, Pagination, Thumbs} from 'swiper/core';
import {mobileActive} from "./handle-mobile";

import loadContents from './content-loader';
import _isArray from "lodash/isArray";
import _each from "lodash/each";

Swiper.use([Navigation, Pagination, Thumbs]);

async function handleSlideChange(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    // if we have a data-load property, we should fetch tab content from url
    if (activeSlide.dataset.load) {
        loadContents(activeSlide, () => {
            window.setTimeout(() => swiper.update(), 100);
        });
    }
}

function loadSwiper(element, doneCallback)
{
    let galleryThumbs = new Swiper(element.querySelector('.gallery-thumbs'), {
        spaceBetween: 0,
        slidesPerView: 2,
        freeMode: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        threshold: 10,
        autoHeight: true,
        observer: true,
        observeParents: true,
        navigation: {
            nextEl: '.js-swiper-button-next',
            prevEl: '.js-swiper-button-prev',
        },
        breakpoints: {
            420: {
                slidesPerView: 3
            },
            769: {
                slidesPerView: 4
            },
            1024: {
                slidesPerView: 5
            },
            1200: {
                slidesPerView: 7
            }
        }
    });

    let galleryTop = new Swiper(element.querySelector('.gallery-top'), {
        spaceBetween: 0,
        freeMode: false,
        observer: true,
        observeParents: true,
        thumbs: {
            swiper: galleryThumbs
        },
        autoHeight: true,

        on: {
            activeIndexChange: handleSlideChange,
            afterInit: handleSlideChange
        }
    });

    // when we have a done callback, trigger it and pass current element and the generated swipers.
    if (typeof doneCallback == 'function') {
        doneCallback(element, galleryThumbs, galleryTop);
    }
}

/**
 * load swipers for given elements or element
 * @param {Array<Object>, Object} elements
 * @param {function=} doneCallback
 */
const loadSwipers = function(elements, doneCallback) {
    if (_isArray(elements) || elements instanceof NodeList) {
        _each(elements, (el) => loadSwiper(el, doneCallback));
    } else {
        loadSwiper(elements, doneCallback);
    }
}

const swipersToLoad = document.querySelectorAll('.is-swiper[data-swiper-with-thumbs]');

if (swipersToLoad.length > 0) {
    loadSwipers(swipersToLoad);
}

export default loadSwipers
